import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {NavigationService} from '../../../services/navigation.service';
import {initDropdown, toggleSidebar} from '../../../helpers/layout.helper';
import {getLogo} from '../../../helpers/assets.helper';
import {CurrentUserService} from '../../../services/current-user.service';
import {SidebarItem} from '../../../models/sidebar-item.model';

@Component({
  selector: 'fa-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, AfterViewInit {

  @Input() style = 'expanded';
  logo: string = getLogo();
  items: SidebarItem[] = [
    // Dashboard
    {
      label: 'STATISTICS',
      icon: 'icon_dashboard',
      isActive: this.isActive(['dashboard']),
      childrens: [
        {
          label: 'Dashboard',
          icon: 'icon_dashboard',
          routerLink: this.navigation.getRouterLink('dashboard'),

          isActive: this.isActive(['dashboard']),
        }
      ]
    },
    // Pages Course
    {
      label: 'COURSE',
      icon: 'icon_courses_manager',
      isActive: this.isActive(['courses']),
      childrens: [
        {
          label: 'Course Manager',
          icon: 'icon_courses_manager',
          isActive: this.isActive(['courses']),
          routerLink: this.navigation.getRouterLink('courses'),
        },
        {
          label: 'My Quizzes',
          icon: 'icon_my_quizzes',
          isActive: this.isActive(['my_quizzes']),
          routerLink: this.navigation.getRouterLink('my_quizzes')
        },
        {
          label: 'My Lessons',
          icon: 'icon_my_lessons',
          isActive: this.isActive(['my_lessons']),
          routerLink: this.navigation.getRouterLink('my_lessons')
        }
      ]
    },
    {
      label: 'USERS',
      icon: 'icon_students',
      isActive: this.isActive(['students']),
      childrens: [
        {
          label: 'Students',
          icon: 'icon_students',
          isActive: this.isActive(['students']),
          routerLink: this.navigation.getRouterLink('students')
        },
        {
          label: 'Groups',
          icon: 'icon_groups',
          isActive: this.isActive(['groups']),
          routerLink: this.navigation.getRouterLink('groups')
        }
      ]
    },

    // {
    //   label: 'Create User',
    //   icon: 'person',
    //   isActive: this.isActive(['users', 'list'], ['users', 'add'], ['users', 'edit'], ['users', 'profile']),
    //   isHidden: () => !this.currentUser.isAdmin(),
    //   routerLink: this.navigation.getRouterLink('users', 'add')
    // },

    {
      label: 'Student Progress',
      icon: 'icon_progress',
      isActive: this.isActive(['student_progress']),
      childrens: [
        {
          label: 'Student Progress',
          icon: 'icon_progress',
          routerLink: this.navigation.getRouterLink('student_progress')
        }
      ]
    },
    {
      label: 'Reset Password',
      icon: 'icon_reset_password',
      isActive: this.isActive(['reset_password']),
      childrens: [
        {
          label: 'Reset Password',
          icon: 'icon_reset_password',
          isActive: this.isActive(['reset_password']),
          routerLink: this.navigation.getRouterLink('group')
        },
        {
          label: 'Sign Out',
          icon: 'icon_sign_out',
          routerLink: this.navigation.getRouterLink('logout')
        }
      ]
    },
    // // Posts
    // {
    //   label: 'Posts',
    //   icon: 'description',
    //   isActive: this.isActive(['posts', 'list'], ['posts', 'add'], ['posts', 'edit'], ['posts', 'translate'], ['posts', 'categories']),
    //   childrens: [
    //     {
    //       label: 'List',
    //       routerLink: this.navigation.getRouterLink('posts', 'list')
    //     },
    //     {
    //       label: 'Add',
    //       routerLink: this.navigation.getRouterLink('posts', 'add')
    //     },
    //     {
    //       label: 'Categories',
    //       routerLink: this.navigation.getRouterLink('posts', 'categories')
    //     }
    //   ]
    // },
    // Users
    // {
    //   label: 'Users',
    //   icon: 'person',
    //   isActive: this.isActive(['users', 'list'], ['users', 'add'], ['users', 'edit'], ['users', 'profile']),
    //   isHidden: () => !this.currentUser.isAdmin(),
    //   childrens: [
    //     {
    //       label: 'List',
    //       routerLink: this.navigation.getRouterLink('users', 'list')
    //     },
    //     {
    //       label: 'Add',
    //       routerLink: this.navigation.getRouterLink('users', 'add')
    //     }
    //   ]
    // },
    // Translations
    // {
    //   label: 'Translations',
    //   icon: 'language',
    //   routerLink: this.navigation.getRouterLink('translations')
    // },
    // {
    //   label: 'Menus',
    //   icon: 'menu',
    //   routerLink: this.navigation.getRouterLink('menus')
    // },
    // {
    //   label: 'Comments',
    //   icon: 'comment',
    //   isActive: this.isActive(['comments', 'list'], ['comments', 'add'], ['comments', 'edit']),
    //   childrens: [
    //     {
    //       label: 'List',
    //       routerLink: this.navigation.getRouterLink('comments', 'list')
    //     },
    //     {
    //       label: 'Add',
    //       routerLink: this.navigation.getRouterLink('comments', 'add')
    //     }
    //   ]
    // },
    // {
    //   label: 'Media',
    //   icon: '&#xE251;',
    //   isActive: this.isActive(['media', 'list'], ['media', 'add'], ['media', 'edit']),
    //   childrens: [
    //     {
    //       label: 'List',
    //       routerLink: this.navigation.getRouterLink('media', 'list')
    //     },
    //     {
    //       label: 'Add',
    //       routerLink: this.navigation.getRouterLink('media', 'add')
    //     }
    //   ]
    // },
  ];

  constructor(public navigation: NavigationService, private currentUser: CurrentUserService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    initDropdown();
  }

  private isRouteActive(...path: string[]) {
    const link = this.navigation.getRouterLink(...path).join('/');
    // console.log(link);
    return this.navigation.router.isActive(link, false);
  }

  private isActive(...routes: any[]) {
    let isActive = false;
    routes.forEach((path: string[]) => {
      if (this.isRouteActive(...path)) {
        isActive = true;
      }
    });
    return isActive;
  }

  toggle() {
    toggleSidebar();
  }

}
